import React, { useState, useEffect } from 'react';
import { FaLightbulb, FaChevronDown, FaChevronUp, FaCheckCircle, FaExclamationTriangle, FaInfoCircle } from 'react-icons/fa';
import * as aiService from '../../../influencer/services/aiService';
import './AIInsights.css';

const AIInsights = ({ stats, title = 'AI Insights' }) => {
  const [insights, setInsights] = useState([]);
  const [loading, setLoading] = useState(false);
  const [expanded, setExpanded] = useState(true);

  useEffect(() => {
    if (stats) {
      generateInsights();
    }
  }, [stats]);

  const generateInsights = async () => {
    setLoading(true);
    try {
      const generatedInsights = await aiService.generateDashboardInsights(stats);
      setInsights(generatedInsights);
    } catch (error) {
      console.error('Failed to generate insights:', error);
      setInsights([]);
    } finally {
      setLoading(false);
    }
  };

  const getIcon = (type) => {
    switch (type) {
      case 'success':
        return <FaCheckCircle className="text-green-500" />;
      case 'warning':
        return <FaExclamationTriangle className="text-yellow-500" />;
      case 'info':
        return <FaInfoCircle className="text-blue-500" />;
      default:
        return <FaLightbulb className="text-orange-500" />;
    }
  };

  const getBorderColor = (type) => {
    switch (type) {
      case 'success':
        return 'border-green-500';
      case 'warning':
        return 'border-yellow-500';
      case 'info':
        return 'border-blue-500';
      default:
        return 'border-orange-500';
    }
  };

  if (loading) {
    return (
      <div className="ai-insights-container">
        <div className="ai-insights-header">
          <FaLightbulb className="text-orange-500" />
          <h3>{title}</h3>
        </div>
        <div className="ai-insights-loading">
          <div className="ai-spinner"></div>
          <span>Generating insights...</span>
        </div>
      </div>
    );
  }

  if (insights.length === 0) {
    return null;
  }

  return (
    <div className="ai-insights-container">
      <div
        className="ai-insights-header"
        onClick={() => setExpanded(!expanded)}
        style={{ cursor: 'pointer' }}
      >
        <div className="flex items-center space-x-2">
          <FaLightbulb className="text-orange-500" />
          <h3>{title}</h3>
          <span className="ai-insights-badge">{insights.length}</span>
        </div>
        {expanded ? <FaChevronUp /> : <FaChevronDown />}
      </div>

      {expanded && (
        <div className="ai-insights-list">
          {insights.map((insight, index) => (
            <div
              key={index}
              className={`ai-insight-item ${getBorderColor(insight.type)}`}
            >
              <div className="ai-insight-header">
                {getIcon(insight.type)}
                <h4 className="ai-insight-title">{insight.title}</h4>
              </div>
              <p className="ai-insight-message">{insight.message}</p>
              {insight.suggestion && (
                <div className="ai-insight-suggestion">
                  <strong>💡 Tip:</strong> {insight.suggestion}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AIInsights;

